<template>
  <div class="pt-3">
    <v-row>
      <v-col cols="12" md="6">
        <title-page title="Managing Contract" />
      </v-col>
      <v-col cols="12" md="6">
        <div class="d-flex justify-end">
          <v-btn
            class="text-capitalize mr-2"
            @click="exportData"
            depressed
            color="var(--g)"
            dark
            >Export Data</v-btn>
            
          <v-btn
            v-if="permissions.includes('UPCM')"
            class="text-capitalize"
            @click="$router.push(`/admin/cm/batch/contract`)"
            depressed
            color="var(--g)"
            dark
            >Import Contract</v-btn>
          <!-- <v-btn
            class="text-capitalize rounded-lg mr-2"
            depressed
            color="var(--g)"
            dark
            @click="generateContract"
            v-if="
              permissions.includes('UPCM') ||
              role == 'SUPERADMIN' ||
              role == 'VENDOR'
            "
            >Generate Contract</v-btn
          >
          <v-btn
            class="text-capitalize"
            depressed
            color="var(--g)"
            dark
            to="/admin/cm/progress-send-contract"
            v-if="
              permissions.includes('UPCM') ||
              role == 'SUPERADMIN' ||
              role == 'VENDOR'
            "
            >View Progres</v-btn
          > -->
        </div>
      </v-col>
    </v-row>
    <div class="mt-10">
      <v-row>
        <v-col cols="12" md="10">
          <div class="d-flex align-center ml-2">
            <v-icon class="magnify">mdi-magnify</v-icon>
            <input
              type="text"
              v-model="find"
              placeholder="Search"
              class="input_green"
            />
          </div>
        </v-col>
        <v-col cols="12" md="2">
          <v-btn
            class="text-capitalize rounded"
            depressed
            color="var(--g)"
            dark
            block
            @click="fetchData"
          >
            Search
          </v-btn>
        </v-col>
      </v-row>
    </div>
    <!--  ========================================================================= data table -->
    <div class="mt-5 py-3">
      <v-skeleton-loader type="table-tbody" v-if="loading"></v-skeleton-loader>
      <div v-if="dataSet && !loading">
        <v-data-table
          :headers="headers"
          :items="dataSet"
          :page.sync="page"
          :items-per-page="limit"
          class="elevation-0 color_txt"
          hide-default-footer
        >
          <template v-slot:[`item.no`]="{ item }">
            {{
              dataSet
                .map((x) => {
                  return x.id;
                })
                .indexOf(item.id) +
              1 +
              (page - 1) * limit
            }}
          </template>
          <template v-slot:[`item.type`]="{ item }">
            TYPE {{ item.data_scholar_contract.type }}
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <v-btn
              :color="
                item.data_scholar_contract.approval == 'approved'
                  ? '#006341'
                  : item.data_scholar_contract.approval == 'declined'
                  ? 'red'
                  : item.data_scholar_contract.approval == 'revision'
                  ? 'orange'
                  : '#757575'
              "
              dark
              rounded
              depressed
              class="text-capitalize"
              small
            >
              {{ item.data_scholar_contract.approval }}
            </v-btn>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <div class="d-flex">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    small
                    depressed
                    fab
                    class="text-capitalize"
                    v-bind="attrs"
                    v-on="on"
                    @click="manageContract(item)"
                  >
                    <v-icon dark small> mdi-pencil </v-icon>
                  </v-btn>
                </template>
                <span>Manage Contract</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
        <div class="py-3" v-if="dataSet">
          <v-row>
            <v-col cols="12" md="6">
              <div class="d-flex align-center">
                <p class="mr-2 mb-0">ROWS PER PAGE</p>
                <div style="width: 100px">
                  <v-select
                    dense
                    hide-details
                    :items="rows"
                    item-text="txt"
                    item-value="val"
                    v-model="limit"
                    @change="fetchData"
                    placeholder="Contract"
                    background-color="var(--g)"
                    dark
                    flat
                    solo
                  ></v-select>
                </div>
              </div>
            </v-col>
            <v-col cols="12" md="6">
              <div class="d-flex justify-end">
                <v-pagination
                  v-model="page"
                  color="#006341"
                  @input="fetchData"
                  :length="last_page"
                ></v-pagination>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
    </div>
    <div class="pa-2">
      <dialog-large
        :d_large="d_large"
        @refetch="fetchData"
        @close="d_large = false"
        :inventory="inventory"
        :type="d_type"
        :title="d_title"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import titlePage from "../../components/atom/titlePage.vue";
export default {
  name: "manageContract",
  components: { titlePage },
  computed: {
    ...mapState({
      permissions: (state) => state.permissions,
      role: (state) => state.role,
    }),
  },
  data() {
    return {
      loading: false,
      dataSet: null,
      page: 1,
      limit: 10,
      total: null,
      last_page: null,
      find: "",
      rows: [5, 10, 50, 100],
      storage_id: [],
      headers: [
        {
          text: "ID",
          align: "start",
          sortable: false,
          value: "no_tf",
        },
        {
          text: "FULL NAME",
          align: "start",
          sortable: false,
          value: "name",
        },
        {
          text: "EMAIL",
          align: "start",
          sortable: false,
          value: "email",
        },
        { text: "TYPE", sortable: false, value: "type" },
        // { text: "STATUS", sortable: false, value: "status" },
        { text: "ACTION", sortable: false, value: "actions" },
      ],
      d_large: false,
      inventory: null,
      d_type: "",
      d_title: "",
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.loading = true;
      let data = {
        path: `manage/contract?filter[search]=${this.find}&page[number]=${this.page}&page[size]=${this.limit}`,
      };
      this.$store
        .dispatch("user/getUser", data)
        .then((data) => {
          this.dataSet = data.data;
          this.total = data.total;
          this.last_page = data.last_page;
          this.loading = false;
        })
        .catch((e) => {
          this.$store.dispatch("notify", {
            msg: e.message,
            type: "error",
          });
          this.loading = false;
        });
    },
    generateContract() {
      this.$router.push("/admin/cm/generate-contract");
    },
    exportData() {
      let data = {
        path: `export/contract`,
        body: {
          "filter[search]": this.find,
        },
      };
      this.$store.dispatch("exportData", data);
    },
    manageContract(item) {
      this.inventory = item;
      this.d_title = "Update Status Contract";
      this.d_type = "m_contract";
      this.d_large = true;
    },
  },
};
</script>

<style scoped>
.input_green {
  border: 2px solid var(--g);
  border-radius: 5px;
  padding: 0 0 0 30px;
  height: 38px;
  background: #fff;
  width: 100%;
}
.input_green:focus {
  outline: none;
}
.magnify {
  margin-right: -30px;
}
</style>
